import { CLIENT_DISPATCH_TARGET_APP } from "redux/clientDispatchMeta";

export interface IClientState {
  isLoaded: boolean;
  error?: any;
  client?: any;
}

export interface IClientAction {
  type: string;
  payload: any;
  meta?: { clientDispatchTarget?: typeof CLIENT_DISPATCH_TARGET_APP };
}

const initialState: IClientState = {
  isLoaded: false,
  error: null,
  client: null,
};

export default function ClientReducer(state = initialState, action: IClientAction): IClientState {
  switch (action.type) {
    case "client.update":
      if (action.meta?.clientDispatchTarget !== CLIENT_DISPATCH_TARGET_APP) {
        return state;
      }
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
